module.exports = __webpack_public_path__ + "img/full4-min.71fec218.png";